import React from 'react';
import styled from 'styled-components';
import { SectionParent, B1, H2, H1 } from '../../StyledComponents';
import Deploy from '../../../assets/Retail/autodeploy.svg';
import Lock from '../../../assets/Retail/lockdevice.svg';
import Remote from '../../../assets/Retail/remote.svg';
import Alerts from '../../../assets/Retail/devicealerts.svg';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { BottomBanner } from '../BottomBanner';

const Section = styled(SectionParent)`
  background: #ffffff;
  padding-top: 5rem !important;
  padding-bottom: 5rem !important;
  @media (max-width: 520px) {
    padding-top: 2rem !important;
    padding-bottom: 0rem !important;
  }
`;

const SectionHeading = styled(H1)`
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.28;
  letter-spacing: normal;
  text-align: center;
  color: #4a5376;
  grid-column: span 12;
  @media (max-width: 520px) {
    font-size: 28px;
  }
`;

const Grid = styled.div`
  display: grid;
  margin-top: 3rem;
  @media (min-width: 520px) {
    grid-template-columns: repeat(3, 1fr);
  }
  @media (max-width: 520px) {
    margin-top: 3rem;
  }
`;

const GridItem = styled.div`
  justify-self: start;
  max-width: 100%;
  grid-column: span 2;
  align-self: center;
  padding-bottom: 2rem;
  @media (max-width: 768px) {
    margin-left: 5rem;
  }
  @media (max-width: 520px) {
    grid-column: span 1;
    margin-bottom: 3rem;
    padding-bottom: 0rem;
    display: grid;
    margin-left: 0rem;
    justify-items: center;
  }
`;
const GridItemRight = styled.div`
  justify-self: center;
  max-width: 100%;
  grid-column: span 2;
  align-self: center;
  padding-bottom: 2rem;
  @media (max-width: 768px) {
    margin-right: 5rem;
  }
  @media (max-width: 520px) {
    grid-column: span 1;
    margin-bottom: 3rem;
    padding-bottom: 0rem;
    display: grid;
    margin-right: 0rem;
    justify-items: center;
  }
`;
const FounderName = styled(H2)`
  padding-top: 2rem;
  @media (max-width: 520px) {
    text-align: left;
  }
  font-size: 24px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.92;
  letter-spacing: normal;
  color: #4d3df4;
`;

const SectionLeftImage = styled(LazyLoadImage)`
  max-width: 250px;
  width: 80%;
  justify-self: end;
  @media (max-width: 520px) {
    margin-left: 0rem;
  }
`;
const SectionRightImage = styled(LazyLoadImage)`
  max-width: 250px;
  width: 80%;
  justify-self: center;
  @media (max-width: 520px) {
    display: none;
  }
`;
const SectionRightImageMobile = styled(LazyLoadImage)`
  max-width: 50%;
  justify-self: center;
  @media (min-width: 521px) {
    display: none;
  }
`;
const SectionSubHeading = styled(H2)`
  padding-top: 1rem;

  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #26315c;
  @media (max-width: 520px) {
    text-align: center;
  }
`;
const SectionSubHeadingRight = styled(H2)`
  padding-top: 1rem;

  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  text-align: left;
  padding-left: 6rem;
  line-height: normal;
  letter-spacing: normal;
  color: #26315c;
  @media (max-width: 520px) {
    text-align: center;
    padding-left: 0;
  }
`;

const SectionContent = styled(B1)`
  font-family: 'Nunito Sans', sans-serif;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.61;
  letter-spacing: normal;
  width: 80%;
  color: #6a718c;

  padding-top: 0.5rem;
  text-align: justify;
  img {
    margin-top: 1rem;
  }
  @media (max-width: 520px) {
    text-align: center;
    width: 90%;
  }
`;

const SectionContentSecond = styled(B1)`
  font-family: 'Nunito Sans', sans-serif;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.61;
  letter-spacing: normal;
  width: 100%;
  padding-left: 6rem;
  color: #6a718c;
  padding-top: 0.5rem;
  text-align: justify;
  img {
    margin-top: 1rem;
  }
  @media (max-width: 520px) {
    padding-left: 0;
    text-align: center;
    width: 90%;
  }
`;

const ImgWrapper = styled.div`
  display: grid;
  align-items: center;
  padding-right: 3rem;
  @media (max-width: 520px) {
    padding-right: 4rem;
  }
`;
export default () => (
  <div>
    <Section>
      <SectionHeading>Benefits Of Esper Manage</SectionHeading>
      <Grid>
        <ImgWrapper>
          <SectionLeftImage src={Deploy} alt="auto deploy" />
        </ImgWrapper>
        <GridItem>
          <SectionSubHeading>
            Configure and Automate Deployment
          </SectionSubHeading>
          <SectionContent>
            Provision your Android-based retail devices using Esper seamlessly
            and with utmost security. Methodically deploy and manage all of your
            devices running in the field.
          </SectionContent>
        </GridItem>
      </Grid>
      <Grid>
        <GridItemRight>
          <SectionRightImageMobile src={Lock} alt="lock" />
          <SectionSubHeadingRight>
            Lock Devices and Gain Complete Control
          </SectionSubHeadingRight>
          <SectionContentSecond>
            Need to build a truly locked down retail device or POS system?
            Here’s the best solution. Esper provides you fine-grained control of
            the system and the ability to manage and provision through the
            entire lifecycle of test, deployment, and support.
          </SectionContentSecond>
        </GridItemRight>
        <ImgWrapper>
          <SectionRightImage src={Lock} alt="lock device" />
        </ImgWrapper>
      </Grid>
      <Grid>
        <ImgWrapper>
          <SectionLeftImage src={Remote} alt="remote" />
        </ImgWrapper>
        <GridItem>
          <SectionSubHeading>Remote Control and Debugging</SectionSubHeading>
          <SectionContent>
            If your retail or POS app happens to fail in the field, no problem,
            just fire up an Esper secure remote debugging session and resolve
            issues without physical intervention.
          </SectionContent>
        </GridItem>
      </Grid>
      <Grid>
        <GridItemRight>
          <SectionRightImageMobile src={Alerts} alt="alerts" />
          <SectionSubHeadingRight>
            Set Alerts For Device Issues
          </SectionSubHeadingRight>
          <SectionContentSecond>
            Did your Android device just turn off? And no way of knowing it?
            Think again. Esper generates instant critical alerts when devices go
            offline, have low battery, or experience security risks.
          </SectionContentSecond>
        </GridItemRight>
        <ImgWrapper>
          <SectionRightImage src={Alerts} alt="alert" />
        </ImgWrapper>
      </Grid>
    </Section>
    <BottomBanner
      description={`Build, Deploy And Manage Your Devices. Book A Demo With Us`}
      buttonText={`Book a demo`}
      link="/book-demo"
    />
  </div>
);
